<template>
  <div>
    <van-tabs
      v-model="active"
      line-height="2px"
      color="#45B9BC"
      sticky
      :swipe-threshold="6"
      title-active-color="#45B9BC"
    >
      <van-tab v-for="(tabItem,tabIndex) in tabList" :key="tabIndex">
        <!--标签标题栏-->
        <div slot="title">{{tabItem.title}}</div>
        <van-list v-model="tabItem.loading" :finished="tabItem.finished" finished-text="没有更多内容啦...">
          <div class="tab__content">
            <div
              class="storeList flex"
              v-for="(storeItem,storeIndex) in tabItem.storeList"
              :key="storeIndex"
            >
              <div class="storeList__img">
                <img :src="storeItem.logo" alt />
              </div>
              <div class="storeList__content">
                <div>{{storeItem.storename}}</div>
                <div class="flex selectStore__subtitle">
                  <div class="col_999 fs_12">
                    <p>地址：{{storeItem.address}}</p>
                    <p>电话：{{storeItem.mobile}}</p>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="storeItem.type===0" class="techList__btn fs_12" @click="join_store(storeItem.id,storeItem.type)">入驻添加</div>
                  <div v-if="storeItem.type===1" class="techList__btn fs_12 cancel__btn" @click="join_store(storeItem.id,storeItem.type)">取消入驻</div>
              </div>
            </div>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import tabBar from "@/components/tabBar.vue"; //引入底部组件
export default {
  name: "book",
  components: { tabBar },
  data() {
    return {
      active: 0, //顶部标签当前位置
      star_active: "#F9CE06", //星星
      // 订单列表
      tabList: [
        {
          id: "0",
          title: "全部",
          // 加载更多
          loading: false,
          finished: true,
          //门店列表
          storeList: []
        },
        {
          id: "1",
          title: "未入驻",
          // 加载更多
          loading: false,
          finished: true,
          //门店列表
          storeList: []
        },
        {
          id: "2",
          title: "已入驻",
          // 加载更多
          loading: false,
          finished: true,
          //门店列表
          storeList: []
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.get_store();
      this.get_instore();
      this.get_noinstore();
    },
    get_store() {
      this.axios({
        url: this.api.store.store_list,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tabList[0].storeList = res.store_data;
        }
      });
    },
    get_instore() {
      this.axios({
        url: this.api.store.get_instore,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.tabList[2].storeList = res.store_data;
        }
      });
    },
    get_noinstore() {
      this.axios({
        url: this.api.store.get_noinstore,
        data: {}
      }).then(res => {
        if (res.error === 0) {
          console.log(res.store_data);
          this.tabList[1].storeList = res.store_data;
        }
      });
    },
    join_store(store_id,join_type){
      this.axios({
        url: this.api.tech.join_store,
        data: {store_id:store_id,join_type:join_type}
      }).then(res => {
        if (res.error === 0) {
          this.$toast({
            message: res.msg,
            onClose: () => {
              this.init();
            }
          });
        }
      });
    },
    // 加载数据
    onLoad() {
      tabList_active.loading = false;
      tabList_active.finished = true;
      // 异步更新数据
      // setTimeout(() => {
      //   // 定义当前所在的数组
      //   var tabList_active=this.tabList[this.active];
      //   // 定义一个变量，取出当前数组的里的list
      //   var list=tabList_active['storeList'];
      //   for (let i = 0; i < 3; i++) {
      //     list.push(list[0]);
      //   }
      //   // 加载状态结束
      //   tabList_active.loading = false;

      //   // 数据全部加载完成
      //   if (list.length >= 10) {
      //     tabList_active.finished = true;
      //   }
      // }, 500);
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/store.css"; /*门店样式*/
@import "../../assets/css/technician.css"; /*技师样式*/
.tab__content {
  padding-top: 0.25rem;
}
.selectStore__subtitle {
  align-items: flex-end;
  -webkit-align-items: flex-end;
}
.cancel__btn {
  background: #eee;
  color: #333;
}
.storeList__content{
  width:48%; 
}
.storeList__img{
  width:3rem;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/tech_selectStore.vue